<!-- Modal Dialog DELETE VEHICLE -->
<ng-template #dialogDeleteVehicle let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>vehicles.deleteHeader</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p translate [translateParams]="{vin: vehicleData?.vehicleInfo.vin}">vehicles.vehicle.deleteVehicleInfo</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteVehicle(); c('No click')"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<!-- Modal Dialog SELECT TYPE -->
<ng-template #dialogSelectType let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row radio-group">
      <label class="container-radio">Exterior
        <input type="radio" name="radio" value="exterior" [(ngModel)]="option">
        <span class="checkmark"></span>
      </label>
      <label class="container-radio">Interior
        <input type="radio" name="radio" value="interior" [(ngModel)]="option">
        <span class="checkmark"></span>
      </label>
      <label class="container-radio">Details
        <input type="radio" name="radio" value="details" [(ngModel)]="option">
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="uploadOldImage(); c('No click')"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<!-- Modal Dialog DELETE IMAGES -->
<ng-template #dialogDeleteImages let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>vehicles.vehicle.imagesHeader</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p translate [translateParams]="{imagesCount: countToDelete}">vehicles.vehicle.deleteImagesMessage</p>
      <!-- <p translate [translateParams]="{imagesCount: imagesToDelete.length}">vehicles.vehicle.deleteImagesMessage</p> -->
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteImages()" translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<div class="container">
  <div *ngIf="!isAllowed" class="check-options">
    <p>Please set the required options!</p>
    <button class="btn-red py-2 px-3 mt-2" (click)="checkSettings()">Options</button>
  </div>
  <div class="row" *ngIf="isAllowed">
    <!-- LOADER -->
    <div *ngIf="isDownloading">
      <div *appSpinner="isDownloading; message: 'Downloading . . .'"></div>
    </div>

    <!-- Images card -->
    <div *ngIf="!isLoading && vehicleData" class="col-sm-12 col-md-12 col-lg-12">
      <div class="warning-alert"
        *ngIf="!staticAlertClosed && user && vehicleData && (+user?.maxCount <= +vehicleData?.vehicleInfo?.count)"
        (close)="staticAlertClosed = true" translate
        [translateParams]="{vehicleNumber: vehicleData?.vehicleInfo?.count, userNumber: user?.maxCount}">vehicles.vehicle.alertAPI</div>
      <div *ngIf="vehicleData.vehicleInfo.importStatus === 'not_available'" class="warning-alert" translate>vehicles.imagesNotAvailable</div>

      <ng-container *ngIf="isProcessingVehicle()">
        <div class="warning-alert" translate>vehicles.sentOnProcessing</div>
      </ng-container>
    </div>

    <!-- <div class="vin-header">
      <label for="" translate>vehicles.title</label>
      <input type="text" autocomplete="off" placeholder="Enter vin number or title here..."
        class="form-input input-larger vin-input" id="vin" name="vin" [(ngModel)]="vehicleData?.vehicleInfo.vin">
      <small translate>vehicles.vehicle.editVin</small>
      <button type="button" class="delete-button bigger-button button-save"
        [hidden]="vehicleData?.vehicleInfo.vin == ''" (click)="saveVehicle()" translate>global.save</button>
    </div> -->

    <div *ngIf="!isLoading && vehicleData" class="vehicle-info-card">
      <div class="vin-header">
        <div class="d-flex justify-content-center">
          <p>VIN: <span class="vin-value">{{vehicleData.vehicleInfo.vin}}</span></p>
          <span *ngIf="['root','customer'].includes(currentUser.role.name) || profilesNumber < 2" class="search-icon ml-3"
            (click)="toggleEditVin = true; toggleUpperCase = false"><i class="fa fa-edit"></i></span>
        </div>

        <img *ngIf="vinImage" class="vin-image" [src]="vinImage.previewFile.thumbnailPath"
          (click)="vinImage.previewFile.thumbnailPath != null && openNewImageModal(0, vinImage, false, false)" />
      </div>

      <div class="vin-header" *ngIf="vehicleData.vehicleInfo.licensePlateNumber || licensePlateNumberImage">
        <div class="d-flex justify-content-center">
          <p><span translate>vehicles.vehicle.licensePlateNumber</span>: <span class="vin-value">{{vehicleData.vehicleInfo?.licensePlateNumber}}</span>
            <span *ngIf="['root', 'customer'].includes(currentUser.role.name) || profilesNumber < 2"
              class="search-icon ml-3" (click)="toggleEditLicensePlate = true; toggleUpperCase = false"><i
                class="fa fa-edit"></i></span></p>
        </div>
        <img *ngIf="licensePlateNumberImage" class="vin-image" [src]="licensePlateNumberImage.previewFile.thumbnailPath"
          (click)="licensePlateNumberImage.previewFile.thumbnailPath != null && openNewImageModal(0, licensePlateNumberImage, false, false)" />
      </div>
    </div>

    <div *ngIf="!isLoading && vehicleData" class="action-toolbar-card">
      <ng-container *ngIf="!isProcessingVehicle()">
        <div class="action-toolbar">
          <!-- Import Group -->
          <div class="action-group" *ngIf="vehicleProfile && vehicleProfile.importers.length">
            <button *ngIf="isCarConfImporter" type="button"
              class="custom-button vehicle-button"
              (click)="importImagesFromCarConf(carConfiguratorImporter.importerId)"
              [disabled]="isImporting || isImportedInfo" translate>features.carconfImport<i><img
                  src="../../../../assets/img/car-confi-import-white.svg" width="17"
                  alt="car confi import" /></i></button>
            <button *ngIf="isAnotherImporters" type="button" class="custom-button vehicle-button"
              (click)="openImportModal()" translate>vehicles.importImages<i class="fa fa-file-import"></i></button>
          </div>

          <!-- Process Group -->
          <div class="action-group" *ngIf="vehicleImages && vehicleImages.length">
            <button type="button" [disabled]="isProcessing"
              class="custom-button vehicle-button" (click)="processVehicle()" translate>vehicles.processVehicle<i
                class="fa fa-camera"></i></button>
            <button *ngIf="currentUser.role.name === 'root'" type="button"
              class="custom-button vehicle-button" (click)="processImage()"
              translate>Process Image<i class="fa fa-camera"></i></button>
          </div>

          <!-- Download Group -->
          <div class="action-group">
            <button type="button" class="custom-button vehicle-button" (click)="downloadImages()"
              translate>vehicles.vehicle.downloadAll<i class="fa fa-file-download ml-2"></i></button>
            <div class="d-flex align-items-center">
              <div class="choose-window">
                <label class="switch" for="withOriginal">
                  <input type="checkbox" [(ngModel)]="withOriginal" name="select" id="withOriginal">
                  <span class="slider round"></span>
                </label>
              </div>
              <label class="checkbox-label" for="withOriginal" translate>vehicles.vehicle.withOriginal</label>
            </div>
          </div>

          <!-- Advanced Group -->
          <div class="action-group">
            <button *ngIf="currentUser.role.name === 'root' && vehicleData.vehicleInfo.status !== 'qc'"
              class="custom-button vehicle-button" (click)="onRestoreImages()">Restore Images <i
                class="fa fa-trash-restore"></i></button>
            <button *ngIf="checkIsThreeSixtyAvailable()" class="custom-button vehicle-button" (click)="onMakeGIF()" translate
              [translateParams]="{threeSixtyType: threeSixtyType}">vehicles.vehicle.makeThreeSixty<i
                class="fa fa-camera"></i></button>
            <button *ngIf="currentUser.role.name === 'root'" class="custom-button vehicle-button"
              (click)="toggleOpenFeatures = true" translate>Features</button>
            <button *ngIf="currentUser.role.name === 'root'" class="custom-button vehicle-button"
              (click)="toggleLicensePlate = true" translate>License Plate Image</button>
          </div>

          <!-- Duplicate Group -->
          <div class="action-group"
            *ngIf="currentUser.role.name !== 'root' && (vehicleData.user.customer.duplicateVehicleEnabled && vehicleData.user.client.duplicateVehicleEnabled) && profilesNumber > 1 && vehicleData.vehicleInfo.profileId === null">
            <button type="button" class="custom-button vehicle-button"
              (click)="onDuplicateVehicle()" translate>Duplicate Vehicle<i class="fa fa-car"></i></button>
          </div>

          <!-- Danger Group -->
          <div class="action-group action-group--danger">
            <button *ngIf="vehicleData.vehicleInfo.status !== 'qc'" class="custom-button vehicle-button btn-red"
              (click)="deleteNew(dialogDeleteImages)"
              translate>vehicles.vehicle.deleteImages<i class="fa fa-trash ml-2"></i></button>
            <button *ngIf="currentUser.role.name !== 'root' && vehicleData.vehicleInfo.status !== 'qc'" type="button"
              class="custom-button vehicle-button btn-red"
              (click)="showDialogDeleteVehicle(dialogDeleteVehicle)" translate>vehicles.vehicle.deleteVehicle<i
                class="fa fa-trash ml-2"></i></button>
          </div>

          <!-- DMS Upload Group -->
          <div class="action-group" *ngIf="vehicleProfile?.dms?.length">
            <p class="action-group-label" translate>vehicles.vehicle.uploadToInterface</p>
            <button *ngFor="let dms of vehicleProfile.dms" class="custom-button vehicle-button btn-red"
              (click)="uploadToInterface(dms.dmsId)">{{dms.dms.name}}<i
                class="fa fa-upload ml-2"></i></button>
          </div>

          <!-- Client DMS Group -->
          <div class="action-group" *ngIf="clientDms?.length">
            <p class="action-group-label" translate>Upload to client interface</p>
            <button class="custom-button vehicle-button btn-red" (click)="toggleOpenClientDMS = true"
              translate>Choose Interface<i class="fa fa-upload ml-2"></i></button>
          </div>
        </div>
      </ng-container>
    </div>
    <!--ng-container
      *ngIf="vehicleData?.vehicleInfo.isProcessed && threeSixtyType === 'GIF'">
      <div (click)="show360 = true" class="chekbox-wrapper">
        <div class="gif-images">
          <p class="d-flex align-items-center justify-content-center"
            style="padding: '5px 10px'; gap: '10px'; color: '#fff'; background: #58585f;">
            360 view - Click to see
            <span>
              <img class="img-fluid" src="../../../../assets/img/360.svg" alt="" style="width: 60px">
            </span>
          </p>
        </div>
      </div>
    </ng-container-->
    <div class="panorama-section" *ngIf="panoramaFrontImages.length || panoramaBackImages.length">
      <ng-container *ngIf="panoramaFrontImages.length">
        <div *ngIf="panoramaFrontImages[0].status !== 'completed'" class="panorama-card panorama-status">
          <p class="panorama-label">Panorama Front -<br>Status: <span
              class="text-uppercase">{{panoramaFrontImages[0]?.status}}</span></p>
        </div>
        <div *ngIf="panoramaFrontImages[0].status === 'completed'" class="panorama-card panorama-clickable">
          <p (click)="openNewImageModal(0, false, true, false)" class="panorama-label d-flex align-items-center justify-content-center">
            Panorama Front - Click to see
            <span>
              <img class="img-fluid" src="../../../../assets/img/panorama-front-white.svg" alt="" style="width: 60px">
            </span>
          </p>
        </div>
      </ng-container>
      <ng-container *ngIf="panoramaBackImages.length">
        <div *ngIf="panoramaBackImages[0].status !== 'completed'" class="panorama-card panorama-status">
          <p class="panorama-label">Panorama Back -<br>Status: <span
              class="text-uppercase">{{panoramaBackImages[0]?.status}}</span></p>
        </div>
        <div *ngIf="panoramaBackImages[0].status === 'completed'" class="panorama-card panorama-clickable">
          <p (click)="openNewImageModal(0, false, false, true)" class="panorama-label d-flex align-items-center justify-content-center">
            Panorama Back - Click to see
            <span>
              <img class="img-fluid" src="../../../../assets/img/panorama-back-white.svg" alt="" style="width: 60px">
            </span>
          </p>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="proVideos.length">
      <div class="section-card w-100 mb-3">
        <p class="pro-videos-header">Pro Videos</p>
        <div class="pro-videos-grid">
          <div *ngFor="let video of proVideos; let i = index" class="pro-video-item">
            <div class="background-main-images"
              (click)="openNewImageModal(0, video, false, false)"
              [style.background-image]="video?.previewFile?.thumbnailPath ?
                'url(' + video.previewFile.thumbnailPath + ')' : 'url(assets/img/no-image.png)'"
              [class.default]="!video?.previewFile?.thumbnailPath">
              <div class="video-overlay"><i class="fa fa-play-circle fa-4x" aria-hidden="true"></i></div>
              <video *ngIf="video?.previewFile?.path?.includes('.mp4')" class="video-player">
                <source src="{{video?.previewFile?.path}}" type="video/mp4" />
                Browser not supported
              </video>
              <video *ngIf="video?.mainFile?.path?.includes('.mp4')" class="video-player">
                <source src="{{video?.mainFile?.path}}" type="video/mp4" />
                Browser not supported
              </video>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="images-section-card section-card w-100">
      <!-- Select All Header -->
      <div class="images-section-header">
        <div class="chekbox-wrapper d-flex justify-content-between" *ngIf="!isLoading && vehicleData">
          <ng-container *ngIf="!isProcessingVehicle()">
            <div style="margin-right: 12px;">
              <input class="checkbox" type="checkbox" [disabled]="vehicleImages && !vehicleImages.length"
                (change)="selectAllImages()" [(ngModel)]="selectAllNew" name="selectAllNew" id="allNew">
              <label class="checkbox-label" for="allNew" translate>vehicles.vehicle.selectAll</label>
            </div>
          </ng-container>
        </div>
        <div class="col chekbox-wrapper d-flex justify-content-between" *ngIf="!isLoading && vehicleData.vehicleInfo.areImagesImported && isCarConfImporter">
          <ng-container *ngIf="!isProcessingVehicle()">
            <div style="margin-right: 12px;">
              <input class="checkbox" type="checkbox" (change)="sortByImported($event)" [(ngModel)]="sortByImg" name="sortByImg"
                id="allNew2">
              <label class="checkbox-label" for="allNew2" translate>vehicles.imports.sortByImported</label>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Image Grid -->
      <div class="fileDivExterior"></div>

      <app-vehicle-placeholder *ngIf="isLoading" [count]="12"></app-vehicle-placeholder>

      <div *ngIf="isDeleted">
        <div class="text-center pt-5">
          <p style="font-size: 1.8rem;" translate>vehicles.vehicle.vehicleErrorInfo</p>
          <small translate>vehicles.vehicle.vehicleErrorDeleted</small>
          <p class="mt-3">Go to <a href="" routerLink="/">Home</a> page.</p>
        </div>
      </div>

      <div *ngIf="!isLoading" class="image-slider image-grid">
        <div *ngFor="let image of allVehicleImages; let index = index" class="image-card">
          <p class="position" [style.background-color]="(image?.previewImageFile?.thumbnail != null) ?
                  'rgba(170, 170, 170, 0.80)' : 'none'" translate [translateParams]="{position: image?.position}">vehicles.vehicle.position</p>
          <div class="background-main-images"
            (click)="(image.previewImageFile.thumbnail != null || image?.type === 'video') && openNewImageModal(index, false, false, false)"
            [style.background-image]="(image?.previewImageFile.thumbnail != null) ?
                  'url(' + image?.previewFile.thumbnailPath + ')' : 'url(assets/img/no-image.png)'"
            [class.default]="!(image?.previewImageFile.thumbnail != null)">

            <div *ngIf="image?.type === 'gif'" class="video-overlay gif">GIF</div>

            <div *ngIf="image?.previewFile?.path.includes('.mp4','.mov') || image?.type === 'video'"
              class="video-overlay"><i class="fa fa-play-circle fa-4x" aria-hidden="true"></i></div>

            <video *ngIf="image?.previewFile?.path.includes('.mp4','.mov')" class="video-player">
              <source src="{{image?.previewFile?.path}}" type="video/mp4" />
              Browser not supported
            </video>

            <video *ngIf="image?.mainFile?.path.includes('.mp4')" class="video-player">
              <source src="{{image?.mainFile?.path}}" type="video/mp4" />
              Browser not supported
            </video>

          </div>

          <ng-container *ngIf="!isProcessingVehicle()">
            <div class="image-settings" *ngIf="image?.previewImageFile.thumbnail != null"
              (click)="editImage(index, image.type)"><i class="fa fa-cog"></i></div>
            <div class="image-upload"
              *ngIf="image?.previewImageFile.thumbnail === null && image.target"
              (click)="openUploadOriginalImage(image)"><i class="fa fa-upload"></i></div>
            <div class="image-upload"
              [style.right]="currentUser.role.name === 'root' || image?.previewImageFile.thumbnail != null ? '30px' : '30px'"
              *ngIf="image?.target?.videoTutorialFileLng"
              (click)="openVideoTutorial(image?.target?.videoTutorialFileLng)"><i class="fa fa-video"></i></div>
            <div>
              <input class="checkbox" type="checkbox" (click)="toggleImageForProcess($event, image)"
                [checked]="image?.isChecked" name="select" id="{{image?.id}}">
              <label class="checkbox-label" for="{{image?.id}}"></label>
            </div>
          </ng-container>
          <div class="target-image" *ngIf="image?.previewImageFile.thumbnail === null && image.target"><img
              [src]="image?.target?.tutorialFile?.fileInfo.thumbnailPath" class="img-fluid" />
          </div>
        </div>
      </div>

      <!-- API Footer -->
      <div *ngIf="!isLoading && vehicleData" class="api-footer">
        <small translate
          [translateParams]="{vehicleNumber: vehicleData?.vehicleInfo?.count, userNumber: user?.maxCount}">vehicles.vehicle.apiCalls</small>
      </div>
    </div>


    <div *ngIf="ex && !panorama">
      <app-image-gallery (close)="exitImagePreview()" [currentImage]="currentImage" [images]="images"
        [isMarkerActive]="isMarkerActive" [currentIndex]="current" [vin]="vehicleData.vehicleInfo.vin"
        [panorama]="panorama"></app-image-gallery>
    </div>

    <div *ngIf="ex && panorama">
      <app-image-gallery (close)="exitImagePreview()" [currentImage]="currentImage" [images]="images"
        [currentIndex]="current" [vin]="vehicleData.vehicleInfo.vin" [panorama]="panorama"></app-image-gallery>
    </div>

    <app-modal (close)="exitImageEdit()" *ngIf="edit">
      <app-image-upload (refresh)="refresh()" (close)="exitImageEdit()" [image]="imageEdit" [vehicleId]="id">
      </app-image-upload>
    </app-modal>

  </div>
</div>

<app-modal (close)="importerInfoPopup = !importerInfoPopup" *ngIf="importerInfoPopup">
  <div class="modal_container black-text">
    <div class="modal-body" translate>vehicles.importRefresh</div>
  </div>
</app-modal>

<app-modal (close)="isImportedInfo = !isImportedInfo" *ngIf="isImportedInfo">
  <div class="modal_container black-text">
    <div class="modal-body" translate>vehicles.importAgainInfo</div>
    <button class="btn btn-default mr-3" (click)="openImportModal(true)" translate>YES</button>
    <button class="btn btn-default" (click)="isImportedInfo = false" translate>NO</button>
  </div>
</app-modal>

<app-modal (close)="toggleImport = !toggleImport" *ngIf="toggleImport">
  <div class="modal_container black-text">
    <div class="modal-body">
      <ng-container *ngFor="let importer of vehicleProfile?.importers">
        <div class="d-flex justify-content-between p-3" *ngIf="importer.importer.module !== 'carconf'">
          <p>{{importer.importer.name}}</p>
          <button class="btn btn-default"
            (click)="importImages(importer.importerId)"
            translate>vehicles.import</button>
        </div>
      </ng-container>
    </div>
  </div>
</app-modal>

<div *ngIf="isImporting">
  <div *appSpinner="isImporting; message: 'Importing images...'"></div>
</div>

<app-modal [priority]="true" (close)="toggleVehicleDetails = false" *ngIf="toggleVehicleDetails">
  <div class="modal_container black-text"
    style="text-align: initial; font-size: 1rem; letter-spacing: 1px; font-weight: 100 !important;">
    <p class="text-header-modal" translate>vehicles.vehicleInfo</p>
    <div *ngIf="vehicleData.vehicleInfo.vinInformations.length">
      <div class="d-flex justify-content-between m-3">
        <span>VIN:</span>
        <span>{{vehicleData.vehicleInfo.vin}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span>Manufacturer:</span>
        <span>{{vehicleData.vehicleInfo.vinInformations[0].manufacturer}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.make</span>
        <span>{{vehicleData.vehicleInfo.vinInformations[0].make}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.model</span>
        <span>{{vehicleData.vehicleInfo.vinInformations[0].model}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.year</span>
        <span>{{vehicleData.vehicleInfo.vinInformations[0].modelYear}}</span>
      </div>
      <div style="text-align: end;">
        <button style="min-width: 100px;" class="custom-button" (click)="toggleVehicleDetails = false">OK</button>
      </div>
    </div>

    <div *ngIf="!vehicleData.vehicleInfo.vinInformations.length">
      <p class="m-5" translate>vehicles.noVinInfo</p>
      <div style="text-align: end;">
        <button style="min-width: 100px;" class="custom-button" (click)="toggleVehicleDetails = false">OK</button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [priority]="true" (close)="toggleDecodeInfo = false" *ngIf="toggleDecodeInfo">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>Decode VIN</p>

    <p style="font-size: 1rem;" translate [translateParams]="{count: decodeVinFeature?.price}" translate>vehicles.decodeVinInfo</p>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-yes" (click)="decodeVin()" translate>global.yes</button>
      <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleDecodeInfo = false;"
        translate>global.no</button>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleEditVin = toggleEditLicensePlate = false" *ngIf="toggleEditVin || toggleEditLicensePlate">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>{{toggleEditVin ? 'vehicles.vehicle.editVin' : 'vehicles.vehicle.editLicensePlateNumber'}}</p>

    <div style="position: relative;" class="form-group">
      <!-- VIN or License Plate Input Field (No Uppercase Handling) -->
      <input *ngIf="!toggleUpperCase" type="text" autocomplete="off"
        [attr.placeholder]="'vehicles.vinOrTitle' | translate" class="form-control" id="vinOrLicensePlate"
        [name]="toggleEditVin ? vehicleData?.vehicleInfo.vin : vehicleData?.vehicleInfo.licensePlateNumber"
        [(ngModel)]="toggleEditVin ? vehicleData?.vehicleInfo.vin : vehicleData?.vehicleInfo.licensePlateNumber"
        (ngModelChange)="isVinModel($event, toggleEditVin)"
        [readonly]="!['root','customer'].includes(currentUser.role.name) && profilesNumber > 1"
        oninput="this.value = this.value.toUpperCase()">

      <!-- VIN or License Plate Input Field with Uppercase Handling -->
      <input *ngIf="toggleUpperCase" type="text" autocomplete="off"
        [attr.placeholder]="'vehicles.vinOrTitle' | translate" class="form-control" id="vinOrLicensePlate"
        [name]="toggleEditVin ? vehicleData?.vehicleInfo.vin : vehicleData?.vehicleInfo.licensePlateNumber"
        [(ngModel)]="toggleEditVin ? vehicleData?.vehicleInfo.vin : vehicleData?.vehicleInfo.licensePlateNumber"
        (ngModelChange)="isVinModel($event, toggleEditVin)"
        [readonly]="!['root','customer'].includes(currentUser.role.name) && profilesNumber > 1">

      <button *ngIf="toggleEditVin" (click)="onDecode()" type="button" placement="top" [ngbTooltip]="decodeVinText"
        class="button-check to-collapse-button-check"></button>
      <button class="button-text" (click)="downCase()" type="button" placement="top"
        [ngbTooltip]="!toggleUpperCase ? offUpperCaseText : onUpperCaseText">
        <i class="fa fa-text-height"></i></button>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleEditVin = false;"
        translate>global.cancel</button>
      <button type="button" class="btn btn-outline-dark btn-yes" (click)="saveVehicle()" translate>global.save</button>
    </div>
  </div>
</app-modal>

<app-modal (close)="onCloseRestore()" *ngIf="toggleRestoreImages">
  <div class="modal_container black-text" style="letter-spacing: initial;">
    <p class="text-header-modal" translate>Restore Images</p>

    <div *ngIf="!restoredImages.length">No Images to restore.</div>

    <div *ngIf="restoredImages.length">
      <div style="position: relative;">
        <div class="chekbox-wrapper" *ngIf="!isLoading && vehicleData">
          <div style="margin-right: 12px;">
            <input class="checkbox" type="checkbox" [disabled]="restoredImages && !restoredImages.length"
              (change)="selectAllDeletedImages()" [(ngModel)]="selectAllDeleted" name="selectAllDeleted"
              id="allDeleted">
            <label class="checkbox-label" for="allDeleted" translate>vehicles.vehicle.selectAll</label>
          </div>
        </div>

        <div *ngFor="let image of restoredImages">
          <div class="d-flex my-2">
            <img style="width: 150px;" [src]="image.previewFile.thumbnailPath" alt="" class="img-fluid">
            <div class="ml-2">
              <p>Position: {{image.position}}</p>
              <p class="small">Deleted: {{image.deletedAt | date:'dd.MM.yyyy HH:mm'}}</p>
              <div>
                <input class="checkbox" type="checkbox" (click)="toggleImageForRestore($event, image)"
                  [checked]="image.isChecked" name="select" id="deleted-{{image.id}}">
                <label class="checkbox-label" for="deleted-{{image.id}}" style="text-align: left;"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleRestoreImages = false;"
          translate>Close</button>
        <button type="button" class="btn btn-outline-dark btn-yes" (click)="restoreImagesHandler()"
          translate>Restore</button>
      </div>
    </div>

  </div>
</app-modal>

<app-modal (close)="toggleOpenClientDMS = false" *ngIf="toggleOpenClientDMS">
  <div class="flex-end flex-column mb-3">
    <p class="ml-2 mb-3" translate style="color: #000;">Connected Interfaces</p>
    <button *ngFor="let dms of clientDms" class="custom-button mx-1 vehicle-button mb-2 btn-red"
      (click)="uploadToClientInterface(dms.dmsId)" translate>{{dms.dms.name}}<i class="fa fa-upload ml-2"></i></button>
  </div>
</app-modal>

<app-modal (close)="toggleOpenUploadImage = false" *ngIf="toggleOpenUploadImage">
  <div class="row align-items-center flex-end flex-column mb-3">
    <div class="img-edit-container">
      <div class="preview-image upload-file" (click)="fileSelect('main')" [style.background-image]="(mainUpload != null) ? 
                          'url(' + mainUpload + ')' : 'url(assets/img/upload-btn.svg)'"
        [style.background-size]="(mainUpload != null) ? '100%' : '40%'"></div>
      <input type="file" name="image" accept="image/x-png,image/jpeg" (change)="getFile($event)" ngModel id="file-main"
        style="display: 'none';" />
    </div>
    <button class="col-3 upload-file-button" [disabled]="isUploadingOriginal" (click)="uploadOriginalImage()">
      <i *ngIf="isUploadingOriginal" class="fa fa-spinner fa-spin"></i>
      <span *ngIf="!isUploadingOriginal">{{ 'Upload' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal (close)="toggleAddPreset = false" *ngIf="toggleAddPreset">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>Select preset</p>
    <app-general-settings-item [icon]="'fa-chart-area'" [title]="'user.defaultPreset'">
      <app-general-settings-select mySelect [currentUser]='user' [options]='presetsList' (select)='patchPreset($event)'
        [processing]='true' [userSettings]="user.userSettings" [defaultSelect]='user.userSettings?.defaultPreset'>
      </app-general-settings-select>
    </app-general-settings-item>
  </div>
</app-modal>

<app-background-setup #dialogBgSetup [settings]="user?.userSettings" [backgrounds]="newBackgrounds"
  [backgroundFiles]="backgroundFiles" (onSaveBgSetup)="SaveBgSetup($event)"></app-background-setup>

<div *ngIf="isUploading">
  <div *appSpinner="isUploading; message: 'Uploading, please wait...'; full: true"></div>
</div>

<ng-container *ngIf="show360">
  <app-threesixty [images]="platformImages" (close)="show360 = false"></app-threesixty>
</ng-container>

<app-modal [priority]="true" (close)="toggleMakeGIF = false" *ngIf="toggleMakeGIF">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate [translateParams]="{threeSixtyType: threeSixtyType}">
      vehicles.vehicle.makeThreeSixty</p>

    <p style="font-size: 1rem;" translate [translateParams]="{threeSixtyType: threeSixtyType}">
      vehicles.vehicle.threeSixtyQuestion
    </p>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-yes" (click)="makeGIF()" translate>global.yes</button>
      <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleMakeGIF = false;"
        translate>global.no</button>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleDuplicateVehicle = false" *ngIf="toggleDuplicateVehicle">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <p class="text-header-modal mb-3" translate>Duplicate Vehicle</p>
    <div>
      <p style="font-size: 1.2rem;" translate [translateParams]="{count: decodeVinFeature?.price}">Select profile(s)
      </p>

      <div class="mx-2 row">
        <form #vehicleDuplicate="ngForm" (ngSubmit)="duplicateVehicle(vehicleDuplicate)">
          <div class="col-12" *ngFor="let profile of profiles; let i =index">
            <label class="custom-checkbox mt-3" *ngIf="profile.id !== null">
              <input class="custom-checkbox-input" ngModel [name]="profile.name" type="checkbox">
              <span class="custom-checkbox-text">{{profile.name}}</span>
            </label>
          </div>
          <button type="submit" class="custom-button btn-red mt-3" style="font-size: 1.2rem;">Duplicate</button>
        </form>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleOpenFeatures = false" *ngIf="toggleOpenFeatures">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <h4 class="text-header-modal font-weight-bold mb-3" translate>global.features</h4>
    <p class="font-weight-bold mb-3">Vehicle features</p>
    <div class="row d-flex justify-content-center">
      <span class="mb-5" *ngIf="!enabledVehicleFatures.length">
        No features included
      </span>
      <span class="feature-item" *ngFor="let feature of enabledVehicleFatures; let i =index">
        {{feature.displayName}}
      </span>
    </div>
    <p class="font-weight-bold mb-3 mt-3">Available features</p>
    <span class="mb-5" *ngIf="!disabledVehicleFeatures.length">
      No features
    </span>
    <app-settings-features *ngIf="disabledVehicleFeatures.length" [features]='disabledVehicleFeatures'
      [panoramaEnabled]='user.customer?.panoramaEnabled' (sendFeature)="patchFeature($event)" vehicleFeatures="true"
      [markersEnabled]="user?.markersEnabled" [isUserFeatures]="true" [user]="user"></app-settings-features>
  </div>
</app-modal>

<app-modal (close)="toggleLicensePlate = false" *ngIf="toggleLicensePlate">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <h4 class="text-header-modal font-weight-bold mb-3" translate>License Plate Image</h4>
    <div class="modal-body">
      <div class="d-flex" style="flex-wrap: wrap;">
        <div class="m-3 p-3">
          <div class="bg-files" (click)="patchLicensePlate(null)"
            [style.background-image]="'url(assets/img/no-image.png)'">
          </div>
        </div>
        <ng-container *ngFor="let plate of licensePlates">
          <div class="position-relative p-3 m-3">
            <div (click)="patchLicensePlate(plate)" class="bg-files bg-hover"
              [ngClass]="{'active': plate.id === vehicleData.vehicleInfo.licensePlateId}"
              [style.background-image]="'url(' + plate.file.thumbnailPath + ')'"></div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="showVideoTutorial = false" *ngIf="showVideoTutorial">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <h4 class="text-header-modal font-weight-bold mb-3" translate>Video tutorial</h4>
    <div class="modal-body">
      <video src={{selectedVideo}} width="100%" height="auto" controls></video>
    </div>
  </div>
</app-modal>

<app-modal (close)="onCloseEditFillableImage()" *ngIf="toggleEditFillableImage">
  <div class="modal_container black-text"
    style="text-align: initial; letter-spacing: initial; font-weight: 100 !important;">
    <div class="modal-body">
      <div>
        <img [src]="selectedFillableImagePath" class="img-fluid" alt="image">
      </div>
      <ng-container *ngIf="textPlaceholders.length; else noPlaceholders">
        <ng-container *ngIf="canSeeForm">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div formArrayName="placeholders">
              <div style="border-bottom: 1px solid #cfcfcf; margin: 1rem 0;"
                *ngFor="let placeholderGroup of placeholdersArray.controls; let i = index" [formGroupName]="i">
                <p class="mb-2" style="font-weight: bold;">{{ placeholderGroup.get('name').value }}</p>
                <div formArrayName="fields">
                  <div *ngFor="let fieldGroup of getFieldsArray(placeholderGroup).controls; let j = index"
                    [formGroupName]="j" class="form-group">
                    <label>{{ fieldGroup.get('key').value }} <span *ngIf="fieldGroup.get('value').validator !== null"
                        style="color: red;">*</span>
                    </label>
                    <input type="text" class="form-control" formControlName="value"
                      [required]="fieldGroup.get('value').validator !== null">
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column" style="gap: 10px">
              <button type="submit" class="custom-button w-100" [disabled]="form.invalid" translate>global.save</button>
            </div>
          </form>
        </ng-container>
      </ng-container>
      <ng-template #noPlaceholders>
        <div style="text-align: center; margin: 1rem 0;" translate>fillableImage.noPlaceholders</div>
      </ng-template>
    </div>
  </div>
</app-modal>

<app-car-configurator-import #carConfigModal [userId]="userId" [vehicleId]="id" [vehicle]="vehicleData"
  [vinDecodeEnabled]="user?.client?.automaticVinDecodeEnabled" [carConfImporter]="carConfiguratorImporter"
  (isImportingChanged)="onIsImportingChanged($event)" (openConfirmRequest)="onOpenConfirmRequest($event)">
</app-car-configurator-import>

<app-modal [priority]="true" (close)="toggleConfirmRequestImages = false" *ngIf="toggleConfirmRequestImages">
  <div class="modal_container black-text">
    <p style="font-size: 1.2rem; font-weight: 600; text-align: center; margin: 1rem 0" translate>vehicles.imports.requestImageSuccessTitle</p>
    <p style="font-size: 1rem; text-align: center;" translate>vehicles.imports.requestImageSuccessText</p>
    <div class="modal-footer mt-4">
      <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleConfirmRequestImages=false"
        translate>Ok</button>
    </div>
  </div>
</app-modal>